var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShipment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6875 0C11.4688 0 12.1875 0.46875 12.5 1.21875L13.8125 4.125C13.9375 4.375 14 4.65625 14 4.9375V12C14 13.125 13.0938 14 12 14H2C0.875 14 0 13.125 0 12V4.9375C0 4.65625 0.03125 4.375 0.15625 4.125L1.46875 1.21875C1.78125 0.46875 2.5 0 3.28125 0H10.6875ZM10.6875 1.5H7.75V4H12.125L11.1562 1.8125C11.0625 1.625 10.875 1.5 10.6875 1.5ZM12.5 5.5H1.5V12C1.5 12.2812 1.71875 12.5 2 12.5H12C12.25 12.5 12.5 12.2812 12.5 12V5.5ZM1.84375 4H6.25V1.5H3.28125C3.09375 1.5 2.90625 1.625 2.8125 1.8125L1.84375 4Z",
    fill: "#61A60E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipment);
export default __webpack_public_path__ + "static/media/Shipment.b51890c00a1aefc4265733eec8f31e42.svg";
export { ForwardRef as ReactComponent };